import apiClient from './client'

export interface SubscriptionTierPricing {
  tier: string
  tier_type: 'personal' | 'organization'
  name: string
  price_monthly: number
  price_yearly?: number
  max_assistants: number
  max_athletes: number
  max_groups: number
  max_coaches: number
  max_members?: number // Only for organization tiers
  max_ai_requests: number
  sort_order: number
}

/**
 * Get all active subscription tiers (both personal and organization)
 */
export async function getAllSubscriptionTiers(): Promise<SubscriptionTierPricing[]> {
  const response = await apiClient.get<SubscriptionTierPricing[]>('/subscription-tiers')
  return response.data
}

/**
 * Get subscription tiers filtered by type
 */
export async function getSubscriptionTiersByType(
  type: 'personal' | 'organization'
): Promise<SubscriptionTierPricing[]> {
  const response = await apiClient.get<SubscriptionTierPricing[]>(`/subscription-tiers/${type}`)
  return response.data
}
